import { precio } from '../../../../libs/cifra/importes';
import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  connect() {
    this.elementImporteTotal = this.element.querySelector('.importe-total .importe');
    this.element.querySelectorAll('input[type=checkbox]').forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        this.#calcularTotalRemesar();
      });
    });
  }

  // Calcula el importe total estimado de la remesa en el partial del listado
  // de cobros al generar una remesa en función de los cobros seleccionados
  #calcularTotalRemesar() {
    let importeTotal = 0;
    this.element.querySelectorAll('input[type=checkbox]:checked').forEach((checkbox) => {
      importeTotal += parseFloat($(checkbox).closest('tr').find('.importe').data('importe-raw'));
    });

    this.elementImporteTotal.textContent = precio(importeTotal);
  }
}
